import React from 'react'

const LaunchDateChangeModal = () => {
  return (
    <div>
      <p>
        If the <span className="bold">campaign assets</span> have already been
        generated,{' '}
        <span className="bold">the campaign assets will be re-generated</span>{' '}
        to reflect the new mailing date.
      </p>
    </div>
  )
}

export default LaunchDateChangeModal
